export default __webpack_public_path__ + "static/folha-78af37f4328cc89cfefff5e461fef725.png";